import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Processes} from './processes';

@Injectable()
export class ProcessesService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('processes?' + params.toString()).map((response: Response) => response.json());
    }
    getAllProcesses() {
        return this.http.get('processes/all').map((response: Response) => response.json());
    }

    getById(_id: string) {
        return this.http.get('processes/' + _id).map((response: Response) => response.json());
    }

    getAllScreens(all:number) {
        return this.http.get('screens/' + all).map((response: Response) => response.json());
    }

    getTrashedById(_id: string) {
        return this.http.get('processes/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('processes/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(processes: Processes) {
        return this.http.post('processes', processes).map((response: Response) => response.json());
    }

    update(processes: Processes) {
        return this.http.put('processes/' + processes.id, processes).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('processes/' + _id).map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/views/management/processes/processes.service.ts